import { atom } from 'jotai';
import { addDays, format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

// export const globalCheckInDateAtom = atom<string>();
// export const globalCheckOutDateAtom = atom<string>();
// export const globalPrevCheckinDateAtom = atom<WbSession['globalPrevCheckinDate']>();
// export const globalPrevCheckoutDateAtom = atom<WbSession['globalPrevCheckoutDate']>();
// export const globalCapacityRoomsAtom = atom<{ adult: number; child: number[] }[]>([
//   {
//     adult: 2,
//     child: [],
//   },
// ]);

// /** 해외숙소 체크인/체크아웃 날짜 및 인원 상태를 관리하는 atom */
// export const globalCheckIOCapacityAtom = atom((get) => {
//   const today = toZonedTime(new Date(), 'Asia/Seoul'); // KST 기준으로 오늘
//   return {
//     checkInDate: get(checkInDateAtom) || format(today, 'yyyy-MM-dd'),
//     checkOutDate: get(checkOutDateAtom) || format(addDays(today, 1), 'yyyy-MM-dd'),
//     capacityRooms: get(globalCapacityRoomsAtom),
//     prevCheckinDate: get(globalPrevCheckinDateAtom),
//     prevCheckoutDate: get(globalPrevCheckoutDateAtom),
//   };
// });

export interface GlobalAccommodationCheckIOCapacity {
  checkInDate: string;
  checkOutDate: string;
  capacityRooms: { adult: number; child: number[] }[];
  prevCheckinDate?: string;
  prevCheckoutDate?: string;
}

export const globalCheckIOCapacityAtom = atom<GlobalAccommodationCheckIOCapacity>({
  checkInDate: format(toZonedTime(new Date(), 'Asia/Seoul'), 'yyyy-MM-dd'),
  checkOutDate: format(addDays(toZonedTime(new Date(), 'Asia/Seoul'), 1), 'yyyy-MM-dd'),
  capacityRooms: [{ adult: 2, child: [] }],
  prevCheckinDate: '',
  prevCheckoutDate: '',
});

export const setGlobalCheckIOCapacityAtom = atom(
  null,
  (get, set, update: Partial<GlobalAccommodationCheckIOCapacity>) => {
    const prev = get(globalCheckIOCapacityAtom);
    set(globalCheckIOCapacityAtom, { ...prev, ...update });
  },
);
